export enum EntityType {
    vehicle, record, part, user
}